import axios, { Canceler } from 'axios'
import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { IMessageResponseDto } from 'src/types'
import {
  ICreateRatingSettingsDto,
  IRatingSettingsRespDto,
  IUpdateRatingSettingsDto,
} from 'src/types/rating-settings.type'

class RatingSettingsService extends EnhancedWithAuthHttpService {
  CancelToken
  languagesCancel?: Canceler
  translationsCancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }

  getRatingSettings(params?: {}) {
    if (this.languagesCancel) {
      this.languagesCancel()
    }

    return this.get<IRatingSettingsRespDto>(`rating-settings`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.languagesCancel = c
      }),
    })
  }

  createRatingSetting(dto: ICreateRatingSettingsDto) {
    if (this.languagesCancel) {
      this.languagesCancel()
    }

    return this.post<IMessageResponseDto, any>(`rating-settings`, dto, {
      cancelToken: new this.CancelToken((c) => {
        this.languagesCancel = c
      }),
    })
  }

  updateRatingSettings(id: string, dto: IUpdateRatingSettingsDto) {
    if (this.languagesCancel) {
      this.languagesCancel()
    }

    return this.put<IMessageResponseDto, any>(`rating-settings/${id}`, dto, {
      cancelToken: new this.CancelToken((c) => {
        this.languagesCancel = c
      }),
    })
  }

  removeRatingSettings(dto: string[]) {
    if (this.languagesCancel) {
      this.languagesCancel()
    }

    return this.post<IMessageResponseDto, any>(`rating-settings/delete`, dto)
  }
}

export const ratingSettingsService = new RatingSettingsService()

export default RatingSettingsService
